<template>
  <div>


<!-- SIDEBAR !!!!  -->
<div id="mySidebar" class="sidebar" style="margin-top:3.7em;">

<div class="box is-radiusless has-background-white" style="margin-bottom:0em;">
<div class="columns is-multiline has-text-white">

<div class="column is-12 colBorder"><a class="button is-fullwidth" @click="sortNav()">Menu&nbsp;&nbsp;<span class="icon is-small"><i class="fas fa-angle-double-left"></i></span></a></div>

<div @click="show_contact() " class="column is-12 has-background-grey-dark colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-mail-bulk"></i></span> &nbsp;ECOLE </div>
<div @click="show_staff()" class="column is-12 has-background-grey-dark colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-users"></i></span> &nbsp;STAFF </div>
<div @click="show_rooms()" class="column is-12 has-background-grey-dark colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-person-booth"></i></span> &nbsp;CLASSROOMS </div>

<div @click="show_communication()" class="column is-12 has-background-grey-dark colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-tty"></i></span> &nbsp;COMMUNICATION </div>


<div @click="show_programs()" class="column mt-4 has-background-grey-dark is-12 colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-chalkboard-teacher"></i></span> &nbsp;PROGRAMS </div>
<div @click="show_competences()" class="column is-12 has-background-grey-dark colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-list-alt"></i></span> &nbsp;COMPETENCES </div>
<div @click="show_courses()" class="column is-12 has-background-grey-dark colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="far fa-list-alt"></i></span> &nbsp;COURSES </div>

<div @click="show_stats()" class="column mt-4 has-background-info is-12 colBorder has-text-white isLink is-size-6 has-text-weight-semibold"><span class="icon"><i class="fas fa-school"></i></span> &nbsp;MESSAGES SENT </div>


</div>
</div>

</div> <!-- end SIDEBAR !!!! -->

<div class="columns is-mobile is-vcentered is-gapless has-background-grey-dark" style="margin-bottom:0em;" >
<div class="column" :class="return_column_width('is-2','is-4')"><a class="button is-borderless is-fullwidth has-background-grey-dark has-text-white" @click="sortNav()"><span class="icon is-small"><i class="fas fa-angle-double-right"></i></span>&nbsp;&nbsp;Menu</a></div>
<div class="column has-text-right has-background-grey-dark has-text-grey-lighter has-text-weight-bold is-size-5" :class="return_column_width('is-10','is-8')">ADMINISTRATION&nbsp;&nbsp;</div>  
</div>

<div id="mainContent" >


<div v-if="view_admin == 'STAFF'">
<CompStaff></CompStaff>
</div> <!-- END STAFF  -->

<!-- <div v-if="view_admin == 'PROGRAMS'">
<CompPeds></CompPeds>
</div>  END PROGRAMS  -->


<CompPedProgram v-if="view_admin == 'PROGRAMS'" ref="childPROG" :key="randomKey()"> </CompPedProgram>
<CompPedCourse v-if="view_admin == 'COURSES'" ref="childCOUR" :prog_id='0' :comp_id='0' :key="randomKey()"> </CompPedCourse>
<CompPedCompetence v-if="view_admin == 'COMPETENCES'" ref="childCOMP" :key="randomKey()"> </CompPedCompetence>

<CompPedStats v-if="view_admin == 'STATS'" ref="childSTAT" :key="randomKey()"> </CompPedStats>

<CompPedRooms v-if="view_admin == 'ROOMS'" ref="childROOM" :key="randomKey()"> </CompPedRooms>

<CompPedCommunication v-if="view_admin == 'COMMUNICATION'" ref="childCOMMUNICATION" :key="randomKey()"> </CompPedCommunication>


<div v-if="view_admin == 'CONTACT'">
<CompContact ref="school_info" @emit_school_change="emit_school_change"></CompContact>
</div> <!-- END CONTACT  -->
 

</div> <!-- end main content !!!! -->


  </div>
</template>

<script>
import CompContact from "@/views/Admin/Comp_Admin_Contact"
import CompPeds from "@/views/Admin/Comp_Admin_Ped"
import CompStaff from "@/views/Admin/Comp_Admin_Staff"

import CompPedCourse from "@/views/Admin/Comp_Admin_Ped_Course"
import CompPedProgram from "@/views/Admin/Comp_Admin_Ped_Program"
import CompPedCompetence from "@/views/Admin/Comp_Admin_Ped_Competence"
import CompPedRooms from "@/views/Admin/Comp_Admin_Ped_Classrooms"
import CompPedStats from "@/views/Admin/Comp_Admin_Ped_Stats"
import CompPedCommunication from "@/views/Admin/Comp_Admin_Ped_Communication"

export default {
  name: 'AdminMain',
  components: {CompContact, CompPeds, CompStaff , CompPedCourse , CompPedProgram , CompPedCompetence, CompPedStats, CompPedRooms, CompPedCommunication},


    data() {
        return {
            isLoading:false,
            navOpen:false,
            view_admin: 'CONTACT',

change_school:false,
change_program:false,
change_staff:false,


        }
    },


beforeRouteLeave:function (to, from, next) {
// CHECKS FOR CHANGE (PAGE -- NEED TO CHECK COMPONENT BELOW)
  if (this.change_school) {
  this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
  position: "centerCenter",
      buttons: [
          {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; next()}},
          {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; next(false)  }},
      ]  });
  } else (next())
},



created () {
    setTimeout(() => { this.openNav(); }, 500);
},

methods: {


// CHECK FOR CHANGES **** 
emit_school_change:function(val){
  this.change_school = val
},



check_dirty_ok:function() {
// CHECK IF SOMETHING CHANGED IN COMPONENT

    if (this.change_school==true || this.change_program==true || this.change_staff==true)  {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter", buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; bReturn = true}},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; bReturn = false  }},
        ]  });
    } else {bReturn = true}

},

show_competences:function() { 
  this.view_admin = "COMPETENCES"
},
show_courses:function() { 
  this.view_admin = "COURSES"
},
show_stats:function() { 
  this.view_admin = "STATS"
},


show_communication:function() { 
    if (this.change_school==true || this.change_program==true || this.change_staff==true)  {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter", buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.change_school=false;this.change_program=false;this.change_staff=false; this.view_admin = 'ROOMS'}},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return false  }},
        ]  });
    } else {this.view_admin = 'COMMUNICATION'} 
}, // END SHOW COMMUNICATION




show_rooms:function() { 
    if (this.change_school==true || this.change_program==true || this.change_staff==true)  {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter", buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.change_school=false;this.change_program=false;this.change_staff=false; this.view_admin = 'ROOMS'}},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return false  }},
        ]  });
    } else {this.view_admin = 'ROOMS'} 
}, // END SHOW STAFF

show_staff:function() { 
    if (this.change_school==true || this.change_program==true || this.change_staff==true)  {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter", buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.change_school=false;this.change_program=false;this.change_staff=false; this.view_admin = 'STAFF'}},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return false  }},
        ]  });
    } else {this.view_admin = 'STAFF'} 
}, // END SHOW STAFF
show_programs:function() {  
    if (this.change_school==true || this.change_program==true || this.change_staff==true)  {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter", buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.change_school=false;this.change_program=false;this.change_staff=false; this.view_admin = 'PROGRAMS'}},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return false  }},
        ]  });
    } else {this.view_admin = 'PROGRAMS'}  
}, // END SHOW PROGRAMS
show_contact:function() {  
    if (this.change_school==true || this.change_program==true || this.change_staff==true)  {
    this.$snotify.error('You have unsaved changes ?', { timeout: 5000, showProgressBar: true, closeOnClick: true, pauseOnHover: false,
    position: "centerCenter", buttons: [
            {text: 'LEAVE', action: (toast) =>  { this.$snotify.remove(toast.id) ; this.change_school=false;this.change_program=false;this.change_staff=false; this.view_admin = 'CONTACT'}},
            {text: 'STAY', action: (toast) => { this.$snotify.remove(toast.id)  ; return false  }},
        ]  });
    } else {this.view_admin = 'CONTACT'}    
}, // END SHOW CONTACT

check_mobile() {
// RETURN COLLEGE NAME - SHORT FOR MOBILE
if (sessionStorage.getItem('isMobile') == 'true')
  {return true}
  else {return false}
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true')
  {return sizeM} else {return sizeD} 
},

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

sortNav() {
    if (this.navOpen) {this.closeNav()} else {this.openNav()}
},
openNav() {
  document.getElementById("mySidebar").style.width = "300px";
  document.getElementById("mainContent").style.marginLeft = "300px";
  this.navOpen = true;
  this.new_show= false;
},
/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
closeNav() {  
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("mainContent").style.marginLeft = "0";
  this.navOpen = false;
},

}



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
